import { Link } from '@factorialco/deprecated-design-system'

import Callout from 'modules/core/components/Callout'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

const CategorySettingsCallout = () => {
  const { navigation } = useNavigation()

  return (
    <Callout
      description={i18n.t(
        'finance.settings.accounting.custom_categories.modals.callouts.category_settings.description'
      )}
      type="info"
      link={
        <Link.Router
          to={navigation.settings.finance.accounting.expenseCategory.fullPath()}
          type="solid"
        >
          {i18n.t(
            'finance.settings.accounting.custom_categories.modals.callouts.category_settings.action'
          )}
        </Link.Router>
      }
    />
  )
}

export default CategorySettingsCallout
